export const Home = `
<div id="home">
<div class="border"></div>
<div class="cursor">
<div id="cursor"></div>
<div id="follower"></div>
</div>
<div class="sec1">
    <div class="navbar">
        <nav>
            <p><a class="navlinks" href="#">AJMAL</a></p>
            <p><a class="navlinks" href="#contact">CONTACT</a></p>
        </nav>
    </div>
    <div class="main">
        <h1>Freelance frontend <span>web developer</span> with a taste for design and <span>interaction.</span> Crafting impactful
        websites to empower <span>digital branding.</span> Working with individuals and companies from all over the world.</h1>
    </div>
</div>
<div class="sec2">
    <h1>About</h1>
    <p>
    My name is Ajmal. I have been learning front end web development for about 2 years. Based in Kerala, India. My goal is to
    become a full stack web developer. I bring your ideas to life. Feel free to contact me if you need help with your website.
    </p>
    <p>
    <span>Skills</span>  HTML / CSS / SCSS / JAVASCRIPT / REACT / WEBGL / THREE JS / PYTHON / PHOTOSHOP /ADOBE XD
    </p>
    <p>Contact Me: ajmalmohad.hello@gmail.com</p>
</div>
<div class="sec3"> 

    <div class="work-1 work">
    <h2>MRAZ</h2>
    <div class="info">
          <p><span>ROLE:</span> FREELANCE DEVELOPER</p>
          <p><span>YEAR:</span> 2022</p>
          <p><a href="https://mraz.co.zw/" target="_blank">VISIT SITE ></a></p>
    </div>
    </div>

    <div class="work0 work">
    <h2>Opensesame</h2>
    <div class="info">
          <p><span>ROLE:</span> FREELANCE DEVELOPER</p>
          <p><span>YEAR:</span> 2022</p>
          <p><a href="https://opensesame.co.zw/" target="_blank">VISIT SITE ></a></p>
    </div>
    </div>

    <div class="work1 work">
    <h2>Hiveboard</h2>
    <div class="info">
          <p><span>ROLE:</span> FRONT END DEVELOPER</p>
          <p><span>YEAR:</span> 2021</p>
          <p><a href="https://hiveboard.netlify.app/" target="_blank">VISIT SITE ></a></p>
    </div>
    </div>
    <div class="work2 work">
    <h2>Sunnyside</h2>
    <div class="info">
          <p><span>ROLE:</span> FRONT END DEVELOPER</p>
          <p><span>YEAR:</span> 2020</p>
          <p><a href="https://sunnyside-ajmal.netlify.app/" target="_blank">VISIT SITE ></a></p>
    </div>
    </div>
    <div class="work3 work">
    <h2>Blogr</h2>
    <div class="info">
          <p><span>ROLE:</span> FRONT END DEVELOPER</p>
          <p><span>YEAR:</span> 2019</p>
          <p><a href="https://blogr-ajmal.netlify.app/" target="_blank">VISIT SITE ></a></p>
    </div>
    </div>
    <div class="work4 work">
    <h2>Blog</h2>
    <div class="info">
          <p><span>ROLE:</span> FULL STACK DEVELOPER</p>
          <p><span>YEAR:</span> 2020</p>
          <p><a href="https://ajmalmohad-blog.netlify.app/" target="_blank">VISIT SITE ></a></p>
    </div>
    </div>
</div>
<div class="sec4" id="contact">
    <h2>Contact Me</h2>
    <div class="links">
    <a href="mailto:ajmalmohad.hello@gmail.com" target="_blank"><p>Gmail</p></a>
    <a href="https://www.instagram.com/ajmalmohad_/" target="_blank"><p>Instagram</p></a>
    <a href="https://www.linkedin.com/in/ajmalmohad/" target="_blank"><p>LinkedIn</p></a>
    <a href="https://github.com/ajmalmohad" target="_blank"><p>Github</p></a>
    <a href="https://twitter.com/ajmalmohad_" target="_blank"><p>Twitter</p></a>
    </div>
</div>
</div>
`;
